export default "__VITE_ASSET__FxBEuQyP__"